import {DestroyRef, Injectable, inject} from '@angular/core'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'
import {Router} from '@angular/router'
import {ToastNotificationService} from '@common/components/toast-notification/toast-notification.service'
import {NetworkService} from '@service/network.service'
import {TranslationServicex} from '@service/translationx.service'

const SILENCED_ROUTES = ['/login', '/sync'] as const

@Injectable({providedIn: 'root'})
export class ConnectivityNotificationService {
  private readonly networkService = inject(NetworkService)
  private readonly router = inject(Router)
  private readonly toastNotificationService = inject(ToastNotificationService)
  private readonly translationServicex = inject(TranslationServicex)
  private readonly destroyRef = inject(DestroyRef)

  init(): void {
    this.networkService.connectivityTransition$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(connected => this.notify(connected))
  }

  private readonly notify = (connected: boolean): void => {
    if (SILENCED_ROUTES.some(route => this.router.url.startsWith(route))) {
      return
    }

    const message = this.translationServicex.instant(
      connected ? 'connectivity_restored_toast' : 'connectivity_lost_toast'
    )

    if (connected) {
      this.toastNotificationService.success(message, null, {closeButton: true})
    } else {
      this.toastNotificationService.error(message, null, {closeButton: true})
    }
  }
}
